<template>
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <timing-period-module :dto="config.timing" :options="options" :compare="false"></timing-period-module>

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Optionen</h6>
            </div>
            <div class="card-body">

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['calculation.columns']"></i>
                        Anzuzeigende Spalten
                    </legend>

                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label><b>PZN</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-name"
                                           v-model="config.pznName">
                                    <label class="form-check-label" for="pzn-name">
                                        Artikelname
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-menge-einheit"
                                           v-model="config.pznMengeEinheit">
                                    <label class="form-check-label" for="pzn-menge-einheit">
                                        Menge und Einheit
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-dar"
                                           v-model="config.pznDar">
                                    <label class="form-check-label" for="pzn-dar">
                                        Darreichungsform
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-anbieter"
                                           v-model="config.pznAnbieter">
                                    <label class="form-check-label" for="pzn-anbieter">
                                        Anbieter
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>BGA</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-name"
                                           v-model="config.bgaNameCity">
                                    <label class="form-check-label" for="bga-name">
                                        Name und Ort
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-dates"
                                           v-model="config.bgaDates">
                                    <label class="form-check-label" for="bga-dates">
                                        Start- und Enddatum
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>Sell-In</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="sell-in-mode-switch"
                                           v-model="config.sellInModeSwitch">
                                    <label class="form-check-label" for="sell-in-mode-switch">
                                        Überweiser in Direktgeschäft
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['rabatt.mode']"></i>
                        Direktrabatt
                    </legend>

                    <div class="form-group">
                        <label><b>Modus</b></label>
                        <select class="form-control" v-model="config.rabattMode">
                            <option value="auto">Automatisch bestimmen</option>
                            <option value="custom">Manuelle Eingabe</option>
                        </select>
                    </div>

                    <div class="form-group" v-if="config.rabattMode !== 'auto'">
                        <label>Direktrabatt</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Prozent</span>
                            </div>
                            <input type="text" class="form-control" placeholder="0" v-model="config.rabattPercent">
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        Vergleichsrabatte
                    </legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['rabatt.ghPercent']"></i>
                            Durchschnittl. GH Kondition
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Prozent</span>
                            </div>
                            <input type="text" class="form-control" placeholder="0" v-model="config.averageGhPercent">
                        </div>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['rabatt.comparePercent']"></i>
                            Vergleichsdirektrabatt
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Prozent</span>
                            </div>
                            <input type="text" class="form-control" placeholder="0" v-model="config.comparePercent">
                        </div>
                    </div>

                </fieldset>

            </div>
        </div>

        <filtering-module :dto="config.filtering"
                          :options="options"
                          :warengruppen="true"
                          :dar="true"
                          :menge="true"
                          :wirkstoffe="true"
                          :reimport="true"></filtering-module>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingPeriodModule from "../Modules/TimingPeriodModule";
import FilteringModule from "../Modules/FilteringModule";

export default {
    components: {FilteringModule, TimingPeriodModule},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto,
        };
    },
    methods: {},
    computed: {}
}
</script>
